import React from 'react';
import { TitleHeader } from 'web-library';
import ExamSummary from '../../modules/examRegistration/components/ExamSummary';

interface ReceiptProps {
  title: string;
}

const Summary = ({ title = '' }: ReceiptProps) => (
  <>
    <TitleHeader title={title} />
    <ExamSummary />
  </>
);

export default Summary;
